import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-activation-error',
  imports: [RouterLink],
  templateUrl: './activation-error.html',
  styleUrl: './activation-error.scss'
})
export class ActivationError {
  resendActivation() {
    // Logique pour renvoyer l'email d'activation
    // this.authService.resendActivationEmail(email) à créer
    console.log("Renvoyer l'email d'activation");
  }

}
